import { c as _c } from "react/compiler-runtime";
/**
  * Do not edit this file manually.
  * It is automatically generated.
  * Run `npm run svg:convert` to regenerate.
  */
import type React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
export default function MountainIcon(props) {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      maskType: "alpha"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <mask id="mask0_11951_160551" style={t0} maskUnits="userSpaceOnUse" x="0" y="0" width="40" height="40"><rect width="40" height="40" /></mask>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <g mask="url(#mask0_11951_160551)"><path d="M13.6257 21.4583L16.7507 23.5417L20.0007 21.9167L23.209 23.5833L26.334 21.5L24.3757 17.5H15.584L13.6257 21.4583ZM7.37565 34.1667H32.6257L27.459 23.75L23.4173 26.4583L20.0007 24.75L16.584 26.4167L12.5007 23.7083L7.37565 34.1667ZM3.33398 36.6667L13.334 16.375C13.5562 15.9583 13.8683 15.625 14.2702 15.375C14.6722 15.125 15.1101 15 15.584 15H18.7507V3.33333H29.334L27.8757 6.24999L29.334 9.16666H21.2507V15H24.2923C24.7626 15 25.192 15.125 25.5807 15.375C25.969 15.625 26.2757 15.9583 26.5007 16.375L36.6673 36.6667H3.33398Z" /></g>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== props) {
    t3 = <SvgIcon {...props}>{t1}{t2}</SvgIcon>;
    $[3] = props;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}